// Official subject per team, shown on the public site for every visitor.
// Teams left out show "To be announced".
export const teamSubjects: Record<number, string> = {
  1: "Embodied AI & Robot Skills",
  2: "Health & Aging-in-Place",
  3: "AI for SMB Manufacturing",
  4: "AI-Native Devices & HMI",
  5: "Edge AI for Smart & Safe Cities",
};
